import { render } from "./ThePriceCompetitorMainInfo.vue?vue&type=template&id=7ec24d42&scoped=true"
import script from "./ThePriceCompetitorMainInfo.vue?vue&type=script&lang=js"
export * from "./ThePriceCompetitorMainInfo.vue?vue&type=script&lang=js"

import "./ThePriceCompetitorMainInfo.vue?vue&type=style&index=0&id=7ec24d42&scoped=true&lang=css"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec24d42"]])

export default __exports__